"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomGoalModuleChildPath = void 0;
exports.CustomGoalModuleChildPath = {
    goalScreener: 'goal-screener',
    needAManagedAccount: 'need-a-managed-account',
    gettingStarted: 'getting-started',
    select: 'select',
    details: 'details',
    contributions: 'contributions',
    confirm: 'confirm',
    confirmConvertGoals: 'confirm-convert-goals',
    success: 'success',
    confirmDelete: 'confirm-delete',
    convertGoalsToManaged: 'convert-goals-to-managed',
    confirmDeleteFromConversion: 'conf-delete-from-convert'
};
